<template>
    <td @click.self="editorOpened=true">
        <div class="model-number-ranges" @click="editorOpened=true">
            <div
                class="range"
                v-for="(range, index) in this.internalRanges"
                :key="index + ':' + range.start + '$$$' + range.end"
            >
                <span class="range-start">{{range.start}}</span>
                <span class="range-separator" v-show="range.end !== ''">-</span>
                <span class="range-end">{{range.end}}</span>
            </div>
        </div>

        <div v-show="editorOpened" class="range-editor-full-screen" @click.self="applyValue">
            <div class="range-editor-window">
                <div class="header">{{$t('Edit Model Number Ranges')}}</div>
                <div class="editor">
                    <div class="ranges">
                        <div
                            class="range"
                            v-for="(range, index) in this.internalRanges"
                            :key="index + ',' + range.start + ',' + range.end"
                        >
                            <ModelNumberInput
                                :pattern="pattern"
                                v-model="range.start"
                            ></ModelNumberInput>
                            <span class="separator"> - </span>
                            <ModelNumberInput
                                :pattern="pattern"
                                v-model="range.end"
                            ></ModelNumberInput>
                            <v-btn class="remove" outlined small elevation="2" @click="removeRange(index)">remove range</v-btn>
                        </div>
                    </div>
                    <div class="buttons">
                        <v-btn class="add"   outlined elevation="3" @click="addRange">add range</v-btn>
                        <v-btn class="apply" outlined elevation="3" @click="applyValue">apply</v-btn>
                    </div>
                </div>
            </div>
        </div>
    </td>
</template>

<script>
import ModelNumberInput from "./ModelNumberInput.vue";

export default {
    name: "ModelNumberRangeCell",
    components: {ModelNumberInput},
    props: {
        readonly: Boolean,
        value:    String,
        pattern:  [RegExp, String]
    },
    methods: {
        convertValueStringIntoRangesArray(value)
        {
            let ranges = [];
            if (!value) {
                return ranges;
            }
            let existingValues = [];
            value.split(',').forEach(range => {
                // remove duplicates
                if (existingValues.includes(range)) {
                    return true;
                }
                existingValues.push(range);
                let rangeArray = range.split('$$$');
                ranges.push({
                    start: rangeArray[0],
                    end:   rangeArray[1] || ''
                });
            });

            return ranges;
        },
        convertRangesArrayIntoValueString()
        {
            let ranges = [];
            let existingValues = [];

            let validRanges = [];
            this.internalRanges.forEach(range => {
                let rangeString = [range.start, range.end].join('$$$');
                if (
                    range.start === ''
                    || existingValues.includes(rangeString)
                ) {
                    return true;
                }
                validRanges.push({start: range.start, end: range.end});
                existingValues.push(rangeString);
                ranges.push(rangeString);
            });

            this.internalRanges = validRanges;

            return ranges.join(',');
        },
        addRange()
        {
            this.internalRanges.push({start: '', end: ''});
        },
        removeRange(index)
        {
            this.internalRanges.splice(index, 1);
        },
        applyValue()
        {
            this.editorOpened = false;
            this.$emit('changeSelection', this.convertRangesArrayIntoValueString());
        }
    },
    data: function() {
        return {
            internalRanges:    this.convertValueStringIntoRangesArray(this.value),
            editorOpened:      false
        }
    },
    computed: {

    }
}
</script>

<style scoped>
    div.model-number-ranges div.range:not(:first-child) {
        border-top: 1px solid var(--table-header-border);
    }

    div.range-editor-full-screen {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: rgba(.5,.5,.5,.5);
        z-index: 100;
    }

    div.range-editor-window {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: white;
        border: 2px solid var(--sc-blue-dark);
        color: var(--sc-blue-dark);
    }

    div.range-editor-window div.header {
        background-color: var(--sc-blue-light);
        padding: 10px;
        font-size: 11pt;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: bold;
        border-bottom: 1px solid var(--sc-blue-dark-5-percent);
    }

    div.range-editor-window div.editor {
        padding: 32px 24px;
    }
    div.range-editor-window div.ranges div.range {
        margin-bottom: 16px;
    }
    div.range-editor-window div.editor div.buttons {
        margin-top: 16px;
    }

    button {
        border: 1px solid var(--sc-blue-light);
        background-color: var(--sc-blue-light-background);
    }

    button.remove {
        margin-left: 16px;
    }
    button.apply {
        margin-left: 16px;
    }

</style>